import { Application } from "@/types/application";
import { Organisation } from "@/types/organisation";
import { UserInterface } from "@/types/user";
import exec from "./abstract.service";
import { replacePathParams, restService } from "./rest.service";

export function getSession() {
    let url = restService.sessionUrl;
    return exec(url, 'get');
}

export function getStatus() {
    let url = restService.statusUrl;
    return exec(url, 'get');
}

export function getVersion() {
    let url = restService.versionUrl;
    return exec(url, 'get');
}

// Redirect to login page & authorize if the user id token is not present in the cookie
export function loginAuthorize() {
    return restService.loginAuthorize;
    // let url = restService.loginAuthorize;
    // return exec(url, 'get');
}

export function redirectToLogin() {
    window.location.href = restService.loginAuthorize;
}

// End Session
export function logout() {
    const url = restService.logoutUrl;
    return exec(url, 'get');
}

// superadmin api's

export function getAllApplications() {
    let url = restService.getAllApplications;
    return exec(url, 'get');
}

export function getAllOrganisations() {
    let url = restService.getAllOrganisations;
    return exec(url, 'get');
}

export function getAllOrganisationsForApp(appName: string) {
    // let url = rest.adminBaseUrl + 'api/domain/';
    // return exec(url, 'get', undefined, { params: { appName }});
}

export function createNewApplication(data: {name: string}) { // This will be deprecated in favour of the old design
    let url = replacePathParams(restService.createNewApplication, { appName: data.name });
    return exec(url, 'post', data);
}

export function addNewApplication(data: Partial<Application>) {
    let url = restService.addNewApplication;
    return exec(url, 'post', data);
}

export function updateNewApplication(data: Partial<Application>, appId: number) {
    let url = replacePathParams(restService.updateApplication, { appId });
    return exec(url, 'put', data);
}

export function getApplicationRoles(appId: number | undefined) {
    let url = replacePathParams(restService.allApplicationRoles, { appId: appId as number });
    return exec(url, 'get');
}

export function getAllApplicationResourceRoles(appId: number | undefined) {
    let url = replacePathParams(restService.allApplicationResourceRoles, { appId: appId as number });
    return exec(url, 'get');
}

export function addNewApplicationRole(postData: {appId: number, role: string, resourceId: number | null, description: string}) {
    let params: any = { appId: postData.appId };
    // if(postData?.resourceId !== undefined && postData?.resourceId !== null ) params['appResourceId'] = postData.resourceId;

    let url = replacePathParams(restService.addNewApplicationRole, params, false);
    return exec(url, 'post', { role: postData.role, description: postData.description }, {params: {appResourceId: postData?.resourceId}});
}

export function updatApplicationeRole(postData: {appId: number, role: string, description: string}) {
    let params: any = { appRoleId: postData.appId };

    let url = replacePathParams(restService.updatApplicationeRole, params, false);
    return exec(url, 'put', { role: postData.role, description: postData.description });
}

export function deleteApplicationRoles(roleId: number) {
    let url = replacePathParams(restService.deleteApplicationRole, { appResourceId: roleId })
    return exec(url, 'delete');
}

// Org-level roles (ORG_APP / ORG_APP_RESOURCE)
export function getOrgManagerAppRoles(appId: number) {
    const url = replacePathParams(restService.getOrgAppRoles, { appId });
    return exec(url, 'get');
}

export function getOrgManagerAppResourceRoles(appResourceId: number) {
    const url = replacePathParams(restService.getOrgAppResourceRoles, { appResourceId });
    return exec(url, 'get');
}

export function addOrgAdminRole(postData: {appId: number, role: string, description: string, appResourceId?: number}) {
    const url = replacePathParams(restService.addOrgRole, { appId: postData.appId });
    return exec(
        url,
        'post',
        { role: postData.role, description: postData.description },
        postData?.appResourceId ? { params: { appResourceId: postData.appResourceId } } : undefined,
    );
}

export function updateOrgAdminRole(postData: {roleId: number, role: string, description: string}) {
    const url = replacePathParams(restService.updateOrgRole, { roleId: postData.roleId });
    return exec(url, 'put', { role: postData.role, description: postData.description });
}

// Super admin org-level roles (ORG_APP / ORG_APP_RESOURCE)
export function getSuperAdminOrgAppRoles(orgId: number, appId: number) {
    const url = replacePathParams(restService.getOrgSpecificAppRoles, { orgId, appId });
    return exec(url, 'get');
}

export function getSuperAdminOrgAppResourceRoles(orgId: number, appResourceId: number) {
    const url = replacePathParams(restService.getOrgSpecificAppResourceRoles, { orgId, appResourceId });
    return exec(url, 'get');
}

export function addSuperAdminOrgRole(postData: {orgId: number, appId: number, role: string, description: string, appResourceId?: number}) {
    const url = replacePathParams(restService.addOrgSpecificRole, { orgId: postData.orgId, appId: postData.appId });
    return exec(
        url,
        'post',
        { role: postData.role, description: postData.description },
        postData?.appResourceId ? { params: { appResourceId: postData.appResourceId } } : undefined,
    );
}

export function updateSuperAdminOrgRole(postData: {orgId: number, roleId: number, role: string, description: string}) {
    const url = replacePathParams(restService.updateOrgSpecificRole, { orgId: postData.orgId, roleId: postData.roleId });
    return exec(url, 'put', { role: postData.role, description: postData.description });
}

export function getApplicationResources(appId: number) {
    let url = replacePathParams(restService.allApplicationResources, { appId });
    return exec(url, 'get');
}

export function addNewApplicationResources(appId: number, postdata: {resource: string, description: string}) {
    let url = replacePathParams(restService.addApplicationResource, { appId });
    return exec(url, 'post', postdata);
}

export function addNewApplicationUri(appId: number, postdata: {type: string, uri: string}) {
    let url = replacePathParams(restService.addApplicationUri, { appId });
    return exec(url, 'post', postdata);
}

export function addNewOrganisationUri(appId: number, orgId: number, postdata: {type: string, uri: string}) {
    let url = replacePathParams(restService.addApplicationUri, { appId });
    return exec(url, 'post', postdata, {params: {orgId: encodeURIComponent(orgId)}});
}

export function deleteApplicationUri(appUriId: number) {
    let url = replacePathParams(restService.deleteApplicationUri, { appUriId });
    return exec(url, 'delete');
}

export function changeApplicationStatus (appId: number, enabled: boolean = true) {
    let url = replacePathParams(restService.enableDisableApplication, { appId, enabled });
    return exec(url, 'put');
}

export function changeOrganisationSatus (orgId: number, enabled: boolean = true) {
    let url = replacePathParams(restService.enableDisableOrganisation, { orgId, enabled });
    return exec(url, 'put');
}

export function createNewOrganisation(postData: Partial<Organisation>) {
    let url = restService.addNewOrganisation;
    return exec(url, 'post', postData);
}

export function updateOrganisationConfigurations(postData: Partial<Organisation>, orgId: number) {
    let url = replacePathParams(restService.updateOrganisationConfiguration, { orgId });
    return exec(url, 'put', postData);
}

// Org admin updates config for their own (logged-in) organisation
export function updateOrgAdminConfigurations(postData: Partial<Organisation>) {
    let url = restService.updateOrgAdminConfiguration;
    return exec(url, 'put', postData);
}

export function updateOrganisation(postData: Partial<Organisation>, orgId: number) {
    let url = replacePathParams(restService.updateOrganisation, { orgId: orgId });
    return exec(url, 'put', postData, {params: {orgId}});
}

export function getAllOrgsMappedToApp(appId: number) {
    let url = replacePathParams(restService.getAllOrganisationsMappedToApplication, {appId});
    return exec(url, 'get');
}

export function getAllAppsMappedToOrg(orgId: number) {
    let url = replacePathParams(restService.getAllApplicationsMappedToOrganisation, {orgId});
    return exec(url, 'get');
}

export function deleteMappingAppToOrg(mapId: number) {
    let url = replacePathParams(restService.removeOrganisationToApplicationMapping, {mapId});
    return exec(url, 'delete');
}

export function createOrgToAppMapping(orgIds: number[], appId: number) {
    let url = replacePathParams(restService.mapOrganisationsToApplication, {appId});
    return exec(url, 'post', orgIds);
}

export function createAppToOrgMapping(appIds: number[], orgId: number) {
    let url = replacePathParams(restService.mapApplicationsToOrganisation, {orgId});
    return exec(url, 'post', appIds);
}

// IP management
export function getIpAddressesForDomain(domainId: number) {
    // let url = rest.adminBaseUrl + 'api/domain/ip';
    // return exec(url, 'get', undefined, {params: { domain: domainId }});
}

export function addIpAddressesToDomain(domainId: number, ipAddresses: string[]) {
    // let url = rest.adminBaseUrl + 'api/domain/ip';
    // return exec(url, 'post', {ipAddresses}, {params: { domain: domainId }});
}

export function removeIpAddressesFromDomain(domainId: number, ipAddresses: string[]) {
    // let url = rest.adminBaseUrl + 'api/domain/ip';
    // return exec(url, 'delete', {ipAddresses}, {params: { domain: domainId }});
}

// Audit logs
export function getAuditLog(postData: any, type: 'admin' | 'domain' = 'admin') {
    // let url = (type === 'admin' ? rest.adminBaseUrl : rest.domainBaseUrl) + 'api/audit';
    let url = type === 'admin' ? restService.getSuperAdminAuditLogs : restService.getOrgAdminAuditLogs;
    return exec(url, 'post', postData);
}

// Auth API's
export function loginOrgName(orgName: string ) {
    // const params = new URLSearchParams({orgName}).toString();

    return restService.loginOrg;
    // return restService.loginOrg + `?${params}`;
    // return exec(url, 'get', undefined, { params: { orgName } });
}

export function loginUsingCredentials(postData: { credential: string, identifier: string }) {
    const params = new URLSearchParams({
        identifier: postData.identifier,
        credential: postData.credential,
    }).toString();

    return restService.loginUsingCredentials + `?${params}`;
    // return exec(url, 'post', undefined, { params: postData });
}

export function changePassword(postData: { oldPassword: string, newPassword: string }) {
    const params = new URLSearchParams({
        oldPassword: postData.oldPassword,
        newPassword: postData.newPassword,
    }).toString();

    return restService.changePassword + `?${params}`;

    // Convert credential to form data
    // let formData = new URLSearchParams();
    // formData.append('oldPassword', postData.oldPassword);
    // formData.append('newPassword', postData.newPassword);

    // return exec(url, 'post', formData, {
    //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    // });
}


export function loginInViaMicrosoftOauth() {
    return restService.oauth2Microsoft;
    // return exec(url, 'get');
}

export function loginInViaGoogleOauth() {
    return restService.oauth2Google;
    // return exec(url, 'get');
}

export function sendMfaOtp() {
    return restService.sendMfaOtp;
    // return exec(url, 'get');
}

export function verifyMfaOtp(otp: string) {
    return replacePathParams(restService.verifyMfaOtp, { otp });
    // return exec(url, 'get');
}

export function sendEmailVerificationToken() {
    return restService.sendEmailVerificationToken;
    // return exec(url, 'get');
}

export function verifyEmailVerificationToken(token: string) {
    let url = replacePathParams(restService.verifyEmailVerificationToken, { token });
    return exec(url, 'get');
}

// FYP API's

export function initFYPFlow(orgName: string, redirectUri: string) {
    return restService.initFypFlow;
    // return exec(url, 'get', undefined, { params: { orgName, redirectUri } });
}

export function getFYPUser(identifier: string) {
    return restService.serachUserExist;
    // return exec(url, 'get', undefined, { params: { identifier } });
}

export function sendFypEmailVerificationToken() {
    return restService.sendToken;
    // return exec(url, 'get');
}

export function setNewPassword(credential: string) {
    const params = new URLSearchParams({
        credential: credential,
        // credential: encodeURIComponent(credential),
    }).toString();

    return restService.setNewPassword + `?${params}`;

    // let url = restService.setNewPassword;
    // Convert credential to form data
    // let formData = new URLSearchParams();
    // formData.append('credential', credential);

    // return exec(url, 'post', formData, {
    //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    // });
}

// Redirect API's
export function openidAuthorizeRedirect(params: URLSearchParams) {
    let url = restService.openidAuthorizeRedirect + '?' + params.toString();
    return exec(url, 'get');
}

export function setCookieRedirect() {
    return restService.setCookieRedirect;
    // return exec(url, 'get');
}

// Domain API's
export function getOrgData() {
    let url = restService.getOrgData;
    return exec(url, 'get');
}

export function getAllApplicationsMappedToOrg(accessLevel: 'admin' | 'domain', orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllApplicationsMappedToOrganisation, {orgId: orgId as number}) : restService.getAllAppsMappedToOrg;
    return exec(url, 'get');
}

export function getAllOrgUsers(accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllUsersForOrg, {orgId: orgId as number}) : restService.getAllOrgUsers;
    return exec(url, 'get');
}

export function getOrgUser(userId: number, accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ?
        replacePathParams(restService.getUserForOrg, {userId, orgId: orgId as number}) :
        replacePathParams(restService.getOrgUser, {userId});
    return exec(url, 'get');
}

export function getAllRoles(accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllRolesForOrg, {orgId: orgId as number}) : restService.getAllRoles;
    return exec(url, 'get');
}

export function getAllResources(accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllAppResourcesForOrg, {orgId: orgId as number}) : restService.getAllAppResources;
    return exec(url, 'get');
}

export function getAllOrgResources(accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllOrgResourcesForOrg, {orgId: orgId as number}) : restService.getAllOrgResources;
    return exec(url, 'get');
}

export function getAllGroups(accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getAllGroupsForOrg, {orgId: orgId as number}) : restService.getAllGroups;
    return exec(url, 'get');
}

export function getGroup(groupId: number, accessLevel: string, orgId?: number) {
    let url = accessLevel === 'admin' ?
        replacePathParams(restService.getGroupForOrg, {groupId, orgId: orgId as number}) :
        replacePathParams(restService.getOrgGroup, {groupId});
    return exec(url, 'get');
}

export function addOrgResourceValue(
    accessLevel: string,
    postdata: {resourceValue: string, description: string},
    appResourceId?: number,
    orgId?: number
) {
    // const appParams = accessLevel === 'admin' ? new URLSearchParams({appResourceId: ''+appResourceId as string}).toString() : undefined;

    let url = accessLevel === 'admin' ?
        replacePathParams(restService.addOrgResourceValue, {orgId: orgId as number}) :
        replacePathParams(restService.addResourceValue, {appResourceId: appResourceId as number})
    return exec(url, 'post', postdata, accessLevel === 'admin' ? {params: {appResourceId}} : undefined);
}

export function changeUserStatus (userId: number, enable: boolean = true, accessLevel: 'admin'|'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.updateSuperadminUserStatus : restService.updateUserStatus, { userId, enable });
    return exec(url, 'put');
}

export function changeUserEmailVerificationStatus (userId: number, enable: boolean = true, accessLevel: 'admin'|'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.updateSuperadminEmailVerificationStatus : restService.updateEmailVerificationStatus, { userId, enable });
    return exec(url, 'put');
}

export function changeUserMFAStatus (userId: number, enable: boolean = true, accessLevel: 'admin'|'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.updateSuperadminMFAStatus : restService.updateMFAStatus, { userId, enable });
    return exec(url, 'put');
}

// User attribute keys are configured at org level (via org configuration) and read here to render user forms
export function getUserAttributeKeys(accessLevel: 'admin'|'domain', orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.getUserAttributeKeysForOrg, {orgId: orgId as number}) : restService.getUserAttributeKeys;
    return exec(url, 'get');
}

export function addNewUser (postdate: any, accessLevel: 'admin'|'domain', orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.addNewSuperadminUser, {orgId: orgId as number}) : restService.addNewUser;
    return exec(url, 'post', postdate);
}

// Bulk-create users. `users` is an array of the same payload shape as addNewUser. Returns a summary with
// per-row results so the caller can build a failure report.
export function bulkAddUsers (users: any[], accessLevel: 'admin'|'domain', orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.bulkAddSuperadminUsers, {orgId: orgId as number}) : restService.bulkAddUsers;
    return exec(url, 'post', { users });
}

export function updateUserDetails(postdata: any, userId: number, accessLevel: 'admin'|'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.updateSuperadminUserDetails : restService.updateUserDetails, { userId });
    return exec(url, 'patch', postdata);
}

export function changeUserPassword(accessLevel: 'admin'|'domain', userId: number, credential: string) {
    let url = replacePathParams(accessLevel === 'admin' ? restService.changeAdminUserPassword : restService.changeUserPassword, {userId});
    // let url = replacePathParams(restService.changeUserPassword, {userId});

    // Convert credential to form data
    let formData = new URLSearchParams();
    formData.append('credential', credential);

    return exec(url, 'put', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        // params: { credential: encodeURIComponent(credential) }
    });
}

export function assignUserRole(postdata: {roleId?: number, typeId: number, orgResourceId?: number | null}, accessLevel: 'admin' | 'domain') {
    let url = accessLevel === 'admin' ? restService.assignSuperadminUserRole : restService.assignUserRole;
    return exec(url, 'put', postdata);
}

export function removeUserRole(postdata: {roleId?: number, typeId: number, orgResourceId?: number | null}, accessLevel: 'admin' | 'domain') {
    let url = accessLevel === 'admin' ? restService.removeSuperadminUserRole : restService.removeUserRole;
    return exec(url, 'put', postdata);
}

export function assignGroupRole(postdata: {roleId?: number, typeId: number, orgResourceId?: number | null}, accessLevel: 'admin' | 'domain') {
    let url = accessLevel === 'admin' ? restService.assignSuperadminGroupRole : restService.assignGroupRole;
    return exec(url, 'put', postdata);
}

export function removeGroupRole(postdata: {roleId?: number, typeId: number, orgResourceId?: number | null}, accessLevel: 'admin' | 'domain') {
    let url = accessLevel === 'admin' ? restService.removeSuperadminGroupRole : restService.removeGroupRole;
    return exec(url, 'put', postdata);
}

export function addUserToGroup(groupId: number, userId: number, accessLevel: 'admin' | 'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.addSuperadminUserToGroup : restService.addUserToGroup, { groupId, userId });
    return exec(url, 'post');
}

export function removeUserFromGroup(groupId: number, userId: number, accessLevel: 'admin' | 'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.removeSuperadminUserFromGroup : restService.removeUserFromGroup, { groupId, userId });
    return exec(url, 'delete');
}

export function updateUserSecurity(postdata: any, userId: number, accessLevel: 'admin' | 'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.updateSuperadminUserSecurity : restService.updateUserSecurity, { userId });
    return exec(url, 'put', postdata);
}

export function resetUser(userId: number, accessLevel: 'admin' | 'domain') {
    let url = replacePathParams(accessLevel === 'admin' ? restService.resetSuperadminUser : restService.resetUser, { userId });
    return exec(url, 'put');
}

// Groups
export function addNewGroup (postdate: any, accessLevel: 'admin' | 'domain', orgId?: number) {
    let url = accessLevel === 'admin' ? replacePathParams(restService.addNewSuperadminGroup, {orgId: orgId as number}) : restService.addNewGroup;
    return exec(url, 'post', postdate);
}


// Standard user api's
export function getUserProfile() {
    let url = restService.getStandardUserDetails;
    return exec(url, 'get');
}

export function updateUserProfile(postdata: Partial<UserInterface>) {
    let url = restService.getStandardUserDetails;
    return exec(url, 'patch', postdata);
}

export function getStandardUserAttributeKeys() {
    let url = restService.getStandardUserAttributeKeys;
    return exec(url, 'get');
}

export function changeStandardUserPassword(postData: { oldPassword: string, newPassword: string }) {
    let url = restService.changeStandardUserPassword;

    // Convert credential to form data
    let formData = new URLSearchParams();
    formData.append('oldPassword', postData.oldPassword);
    formData.append('newPassword', postData.newPassword);

    return exec(url, 'post', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
}
